import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { SkapaButton, SkapaModal, SkapaModalFooter, SkapaModalHeader, SkapaPrompt } from '@inter-ikea-guida/skapa';
import { useGuidaPromptContext } from '../context/promptContext';
import { useCommonTranslation } from '../hooks/useCommonTranslation';
const StyledSkapaModal = styled(SkapaModal) `
  z-index: 600;
`;
export const GuidaExitPrompt = () => {
    const { t } = useCommonTranslation();
    const { closePrompt, isPromptVisible, homePageLink } = useGuidaPromptContext();
    const modalProps = {
        visible: isPromptVisible,
        handleCloseBtn: closePrompt
    };
    const promptProps = {
        title: t('ExitPrompt.Title'),
        titleId: 'exit-prompt-title',
        header: _jsx(SkapaModalHeader, { ariaCloseTxt: t('Close'), dataTestId: 'exit-prompt-header' }),
        footer: (_jsxs(SkapaModalFooter, { stacked: true, children: [_jsx(SkapaButton, { text: t('ExitPrompt.SecondaryButton'), onClick: closePrompt, type: 'secondary', dataTestId: 'exit-prompt-secondary-button' }), _jsx(SkapaButton, { text: t('ExitPrompt.PrimaryButton'), href: homePageLink, rel: 'noopener noreferrer', onClick: closePrompt, type: 'primary', dataTestId: 'exit-prompt-primary-button' })] }))
    };
    return (_jsx(StyledSkapaModal, { ...modalProps, "data-testid": 'exit-prompt', children: _jsx(SkapaPrompt, { ...promptProps, children: t('ExitPrompt.Body') }) }));
};
//# sourceMappingURL=GuidaExitPrompt.js.map